import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    InfMunCarregaInterface, infPercurso, ProdutoPredominanteInterface,
    AutorizacaoDownloadInterface, EstadoInterface, MunicipioInterface,
    LacresManifestoInterface,
    infMunDescargaInterface,

    infNFesInterface,
    infCTesInterface,
    ModalRodoviarioInterface,
    ManifestoState,
    Condutor,
    LacreInterface,
    ReboqueInterface,
    CiotInterface,
    ContratanteInterface,
    DispInterface,
    infPagInterface,
    SeguroInterface,
    ModalAereoInterface,
    ModalFerroviarioInterface,
    VagaoInterface,
    ModalAquaticoInterface,
    InfTermCarregInterface,
    infTermDescarregInterface,
    infEmbCombInterface,
    infUnidCargaVaziaInteface,
    infUnidTranspVaziaInterface,
    InfMDFesInterface,
    AverbacaoInterface,
    infProdutoPerigosoInterface,
    infUnidTranspInterface,
    LacUnidadeTransporteInterface,
    InfUnidCargaInterface,
    LacUnidCargaInterface
} from "../interfaces";

const initialModalAquatico: ModalAquaticoInterface = {
    id: 0,
    irin: '',
    tpemb: '01',
    cembar: '',
    xembar: '',
    nviag: '',
    cprtemb: '',
    cprtdest: '',
    prttrans: '',
    tpnav: 9,//nao informado
    infTermCarreg: [],
    infTermDescarreg: [],
    infEmbComb: [],
    infUnidCargaVazia: [],
    infUnidTranspVazia: [],
}

const initialModalAereo: ModalAereoInterface = {
    nac: '',
    matr: '',
    nvoo: '',
    caeremb: '',
    caerdes: '',
    dvoo: ''
}

const initialModalFerroviario: ModalFerroviarioInterface = {
    trem: {
        dhtrem: '',
        qvag: 1,
        xdest: '',
        xori: '',
        xpref: ''
    },
    vag: []
}


export const initialModalRodoviario: ModalRodoviarioInterface = {
    tracao: {
        condutores: [],
        prop: {},
        capKG: '',
        capM3: '',
        placa: '',
        tpCar: '0',
        tara: '',
        cint: '',
        renavam: '',
        tpRod: '1',
        uf: 'RN'
    },
    reboques: [],
    infANTT: {
        rntrc: '',
        infPag: [],
        infCIOT: [],
        infContratante: [],
        valePed: {
            categCombVeic: '',
            disp: []
        }
    },
    lacres: []
}


const initialState: ManifestoState = {
    manifesto: {
        indcanalverde: false,
        indcarregaposterior: false,
        dhiniviagem: '',
        nmdf: "1",
        tpemit: 2,
        tptransp: 0,
        modal: 1,
        chave: '',
        serie: '1',
        mod: '58',
        ufini: "RN",
        uffim: "RN",
        vcarga: 0,
        qcarga: 0,
        cunid: "01",
        dhcancel: '',
        dhemi: '',
        dhencer: '',
        protocolo: '',
        situacao: 1,
        infMunCarrega: [],
        infPercurso: [],
        infMunDescarga: [],
        prodPred: {
            cean: '',
            ncm: '',
            tpcarga: '01',
            xprod: '',
            infLotacao: false,
            infLocalCarrega_cep: '',
            infLocalCarrega_latitude: '',
            infLocalCarrega_longetude: '',
            infLocalDescarrega_cep: '',
            infLocalDescarrega_latitude: '',
            infLocalDescarrega_longetude: ''

        },
        authDownload: [],
        infcpl: "",
        infadfisco: "",
        lacres: [],
        modal_rodoviario: initialModalRodoviario,
        modal_aereo: initialModalAereo,
        modal_ferroviario: initialModalFerroviario,
        modal_aquatico: initialModalAquatico,
        seg: []
    },
    listaErrors: {
        uffim: [],
        ufini: [],
        nmdf: [],
        tpemit: [],
        tptransp: [],
        modal: [],
        infMunCarrega: [],
        infPercurso: [],
        prodPred_cean: [],
        prodPred_ncm: [],
        prodPred_tpcarga: [],
        prodPred_xprod: [],
        modal_rodoviario_tracao_placa: [],
        modal_rodoviario_tracao_tara: [],
        modal_rodoviario_tracao_uf: [],
        modal_rodoviario_tracao_renavam: [],
        modal_rodoviario_tracao_tpcar: [],
        modal_rodoviario_tracao_tpRod: [],

    },

    selectEstados: [{
        id: 0,
        uf: "",
        name: "Selecione uma UF",
        cod_ibge: 0,
        pais: { name: 'Brasil' }
    }],
    selectMunicipios: [
        {
            id: 0,
            name: 'Selecione uma UF Inicial',
            estado: {
                uf: 'Selecione'
            },
            capital: 0,
            cod_ibge: 0,

        }
    ],
    selectMunicipiosCarregamentos: [
        {
            id: 0,
            name: 'Selecione uma UF Final',
            estado: {
                uf: 'Selecione'
            },
            capital: 0,
            cod_ibge: 0,

        }
    ],
    selectMunicipiosDescarregamentos: []
}

const manifestoSlice = createSlice({
    name: "manifesto",
    initialState,
    reducers: {

        changeAnttRntrc: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT,
                            rntrc: action.payload,
                            infCIOT: [],
                            infContratante: [],
                            infPag: [],
                            valePed: {
                                categCombVeic: '',
                                disp: []
                            }
                        }
                    }
                }
            }

        },

        clearError: (state, action) => {
            const { [action.payload]: _, ...novalista } = state.listaErrors

            return {
                ...state,
                listaErrors: { ...novalista }
            }

        },

        loadMunicipiosDescargaSelect: (state) => {
            return {
                ...state,
                selectMunicipiosDescarregamentos: state.manifesto.infMunDescarga.map(item => {
                    return {
                        id: item.municipio_id,
                        name: item.name
                    }
                })

            }
        },

        changeTracaoManifesto: (state, action) => {
            if (state.manifesto.modal_rodoviario) {

                if (state.manifesto.modal_rodoviario?.tracao) {

                    return {
                        ...state,
                        manifesto: {
                            ...state.manifesto,
                            modal_rodoviario: {
                                ...state.manifesto.modal_rodoviario,
                                tracao: { ...state.manifesto.modal_rodoviario.tracao, ...action.payload },
                            }
                        },

                    }
                }
            }
        },

        changeModalFerroviarioTrem: (state, action) => {
            if (state.manifesto.modal_ferroviario) {

                if (state.manifesto.modal_ferroviario?.trem) {

                    return {
                        ...state,
                        manifesto: {
                            ...state.manifesto,
                            modal_ferroviario: {
                                ...state.manifesto.modal_ferroviario,
                                trem: { ...state.manifesto.modal_ferroviario.trem, ...action.payload },
                            }
                        },

                    }
                }
            }
        },

        changeTracaoProp: (state, action) => {
            if (state.manifesto.modal_rodoviario) {

                if (state.manifesto.modal_rodoviario?.tracao) {

                    return {
                        ...state,
                        manifesto: {
                            ...state.manifesto,
                            modal_rodoviario: {
                                ...state.manifesto.modal_rodoviario,
                                tracao: {
                                    ...state.manifesto.modal_rodoviario.tracao,
                                    prop: { ...state.manifesto.modal_rodoviario.tracao.prop, ...action.payload }
                                },
                            }
                        },

                    }
                }
            }
        },

        clearTracaoProp: (state) => {
            if (state.manifesto.modal_rodoviario) {

                if (state.manifesto.modal_rodoviario?.tracao) {

                    return {
                        ...state,
                        manifesto: {
                            ...state.manifesto,
                            modal_rodoviario: {
                                ...state.manifesto.modal_rodoviario,
                                tracao: {
                                    ...state.manifesto.modal_rodoviario.tracao,
                                    prop: {}
                                },
                            }
                        },

                    }
                }
            }

        },

        addCondutor: (state, action: PayloadAction<Condutor>) => {
            console.log('condutor', action.payload)
            state.manifesto.modal_rodoviario.tracao.condutores.push(action.payload)
        },

        removerCondutorTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        tracao: {
                            ...state.manifesto.modal_rodoviario.tracao,
                            condutores: []
                        }
                    }
                }
            }

        },
        removeCondutor: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        tracao: {
                            ...state.manifesto.modal_rodoviario.tracao,
                            condutores: state.manifesto.modal_rodoviario.tracao.condutores.filter((item: Condutor) => item.id.toString() !== action.payload.toString())
                        }
                    }
                }
            }

        },

        setManifesto: (state, action) => {
            state.manifesto = { ...state.manifesto, ...action.payload }

            if (action.payload['modal']) {
                state.manifesto = { ...state.manifesto, modal_rodoviario: {} }
                state.manifesto = { ...state.manifesto, modal_aereo: {} }
                state.manifesto = { ...state.manifesto, modal_ferroviario: {} }
                state.manifesto = { ...state.manifesto, modal_aquatico: {} }

                if (action.payload['modal'] === '1') {
                    state.manifesto = { ...state.manifesto, modal_rodoviario: initialModalRodoviario }
                }

                if (action.payload['modal'] === '2') {
                    state.manifesto = { ...state.manifesto, modal_aereo: initialModalAereo }
                }

                if (action.payload['modal'] === '4') {
                    state.manifesto = { ...state.manifesto, modal_ferroviario: initialModalFerroviario }
                }

                if (action.payload['modal'] === '3') {
                    state.manifesto = { ...state.manifesto, modal_aquatico: initialModalAquatico }
                }
            }

        },

        clearManifesto: (state) => {
            return initialState;
        },

        loadManifesto: (state, action) => {
            return {
                ...state,
                manifesto: action.payload
            }
        },

        gravarErrors: (state, action) => {

            return {
                ...state,
                listaErrors: { ...action.payload }
            };
        },

        changeProdutoPredominante: (state, action) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    prodPred: { ...state.manifesto.prodPred, ...action.payload }
                }
            }
        },

        changeModalAereo: (state, action) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aereo: { ...state.manifesto.modal_aereo, ...action.payload }
                }
            }
        },

        addLacreManifesto: (state, action: PayloadAction<LacresManifestoInterface>) => {
            state.manifesto.lacres.push(action.payload);
        },

        removerLacreManifesto: (state, action: PayloadAction<number | string>) => {
            if (state.manifesto.lacres.find(item => item.id === action.payload)) {
                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        lacres: state.manifesto.lacres.filter(item => item.id !== action.payload)
                    }
                }
            }
        },
        removerLacreManifestoTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    lacres: []
                }
            }
        },

        addLacreRodoviario: (state, action: PayloadAction<LacresManifestoInterface>) => {
            state.manifesto.modal_rodoviario.lacres.push(action.payload);
        },

        removerLacreRodoviario: (state, action: PayloadAction<number | string>) => {
            if (state.manifesto.modal_rodoviario.lacres.find((item: LacreInterface) => item.id === action.payload)) {
                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        modal_rodoviario: {
                            ...state.manifesto.modal_rodoviario,
                            lacres: state.manifesto.modal_rodoviario.lacres.filter((item: LacreInterface) => item.id !== action.payload)
                        }
                    }
                }
            }
        },

        removerLacreRodoviarioTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        lacres: []
                    }
                }
            }
        },

        addAuthDownload: (state, action: PayloadAction<AutorizacaoDownloadInterface>) => {
            state.manifesto.authDownload.push(action.payload);
        },

        removeAuthDownload: (state, action: PayloadAction<number | string>) => {

            if (state.manifesto.authDownload.find(item => item.id === action.payload)) {
                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        authDownload: state.manifesto.authDownload.filter((item: AutorizacaoDownloadInterface) => item.id !== action.payload)
                    }
                }
            }

        },

        removeAuthDownloadTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    authDownload: []
                }
            }

        },

        addListaMunicipiosCarregamento: (state, action: PayloadAction<InfMunCarregaInterface>) => {
            state.manifesto.infMunCarrega.push(action.payload);
        },

        removeMunicipioCarregamento: (state, action: PayloadAction<number | string>) => {

            return {
                ...state,
                listaMunicipiosCarregamento: state.manifesto.infMunCarrega.filter((municipio: InfMunCarregaInterface) => municipio.id?.toString() !== action.payload.toString()),
                manifesto: {
                    ...state.manifesto,
                    infMunCarrega: state.manifesto.infMunCarrega.filter((municipio: InfMunCarregaInterface) => municipio.id?.toString() !== action.payload.toString())
                }
            }
        },

        removeMunicipioCarregamentoTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infMunCarrega: []
                }
            }
        },

        addListaUFPercurso: (state, action: PayloadAction<infPercurso>) => {
            state.manifesto.infPercurso.push(action.payload);
        },

        removeListaUFPercurso: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infPercurso: state.manifesto.infPercurso.filter((estado: infPercurso) => estado.id.toString() !== action.payload.toString())
                }
            }
        },

        removeListaUFPercursoTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infPercurso: []
                }
            }
        },

        setEstados: (state, action: PayloadAction<EstadoInterface[]>) => {
            return {
                ...state,
                selectEstados: [...state.selectEstados, ...action.payload]
            }
        },

        setSelectMunicipios: (state, action: PayloadAction<MunicipioInterface[]>) => {
            state.selectMunicipios = action.payload;
        },

        setSelectMunicipiosCarregamento: (state, action: PayloadAction<MunicipioInterface[]>) => {
            state.selectMunicipiosCarregamentos = action.payload;
        },

        setinfMunCarrega: (state, action: PayloadAction<InfMunCarregaInterface>) => {
            state.manifesto.infMunCarrega.push(action.payload);
        },

        removeInfMunCarrega: (state, action: PayloadAction<number>) => {
            return {
                ...state,
                infMunCarrega: state.manifesto.infMunCarrega.filter((municipio: InfMunCarregaInterface) => municipio.municipio_id !== action.payload)
            }
        },

        setinfPercurso: (state, action: PayloadAction<infPercurso>) => {
            state.manifesto.infPercurso.push(action.payload);
        },

        removeInfPercurso: (state, action: PayloadAction<number>) => {
            return {
                ...state,
                infPercurso: state.manifesto.infPercurso.filter((estado: infPercurso) => estado.estado_id !== action.payload)
            }
        },

        setProdPred: (state, action: PayloadAction<ProdutoPredominanteInterface>) => {
            state.manifesto.prodPred = action.payload
        },

        removeProdPred: (state) => {
            return {
                ...state,
                prodPred: {}
            }
        },

        addListaMunicipiosDescarregamento: (state, action: PayloadAction<infMunDescargaInterface>) => {

            state.manifesto.infMunDescarga.push({
                id: action.payload.id,
                municipio_id: action.payload.municipio_id,
                name: action.payload.name,
                infNFe: [],
                infCTe: [],
                infMDFe: []
            });

            if (!state.selectMunicipiosDescarregamentos.find(item => item.id === action.payload.municipio_id)) {

                state.selectMunicipiosDescarregamentos.push({ id: action.payload.municipio_id, name: action.payload.name });
            }

        },

        removeListaMunicipioDescarregamento: (state, action: PayloadAction<number | string>) => {
            const municipioId = state.manifesto.infMunDescarga.filter((municipio: infMunDescargaInterface) => municipio.id.toString() === action.payload.toString())[0].municipio_id

            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infMunDescarga: state.manifesto.infMunDescarga.filter((item: infMunDescargaInterface) => item.id.toString() !== action.payload.toString())
                },
                selectMunicipiosDescarregamentos: state.selectMunicipiosDescarregamentos.filter(item => item.id !== municipioId)
            }
        },

        removeListaMunicipioDescarregamentoTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infMunDescarga: []
                },
                selectMunicipiosDescarregamentos: state.selectMunicipiosDescarregamentos
            }
        },

        addNFe: (state, action: PayloadAction<infNFesInterface>) => {
            const index = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())

            if (index !== -1) {
                state.manifesto.infMunDescarga[index].infNFe?.push(action.payload)
            }

        },

        updateNFe: (state, action: PayloadAction<infNFesInterface>) => {

            const nfe = state.manifesto.infMunDescarga.flatMap((item) => item.infNFe as infNFesInterface[]).find((item) => item.id === action.payload.id);

            if (nfe) {
                const index = state.manifesto.infMunDescarga.findIndex(item => item.municipio_id.toString() === nfe.municipio_id.toString());

                if (index !== -1) {
                    let newLista = state.manifesto.infMunDescarga[index].infNFe?.filter((item: infNFesInterface) => item.id !== action.payload.id) || []
                    state.manifesto.infMunDescarga[index].infNFe = newLista;

                    const index2 = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())

                    if (index2 !== -1) {
                        state.manifesto.infMunDescarga[index2].infNFe?.push(action.payload)
                    }
                }
            }
        },

        removeNFe: (state, action: PayloadAction<{ municipio_id: number; id: string | number }>) => {

            const munDescarga = state.manifesto.infMunDescarga.filter((item: infMunDescargaInterface) => item.municipio_id === action.payload.municipio_id)
            const index = state.manifesto.infMunDescarga.findIndex((item: infMunDescargaInterface) => item.municipio_id === action.payload.municipio_id)


            if (index !== -1) {
                let newLista = state.manifesto.infMunDescarga[index].infNFe?.filter((item: infNFesInterface) => item.id?.toString() !== action.payload.id.toString()) || []

                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        infMunDescarga: [
                            ...state.manifesto.infMunDescarga.filter(item => item.municipio_id !== action.payload.municipio_id),
                            {
                                id: munDescarga[0].id,
                                municipio_id: action.payload.municipio_id,
                                name: munDescarga[0].name,
                                infNFe: newLista,
                                infCTe: munDescarga[0].infCTe,
                                infMDFe: munDescarga[0].infMDFe

                            }
                        ]
                    }
                }
            }

        },

        clearNFe: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infMunDescarga: [...state.manifesto.infMunDescarga.map(item => {
                        return {
                            id: item.id,
                            municipio_id: item.municipio_id,
                            name: item.name,
                            infNFe: [],
                            infMDFe: item.infMDFe,
                            infCTe: item.infCTe
                        }
                    })]

                },
            }
        },

        addProdutoPerigosoMDFe: (state, action: PayloadAction<{
            mdfeId: number | string; peri: infProdutoPerigosoInterface
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infMDFe?.some((mdfe: InfMDFesInterface) =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString())
            )
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex]
                    .infMDFe?.find(mdfe => mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    mdfe.peri = mdfe.peri || [];
                    mdfe.peri.push(action.payload.peri);
                }
            }
        },

        removeProdutoPerigosoMDFe: (state, action: PayloadAction<{
            mdfeId: number | string; id: number | string
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infMDFe?.some((n: InfMDFesInterface) =>
                    n?.id?.toString() === action.payload.mdfeId.toString())
                )
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe
                    ?.find(n => n?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    mdfe.peri = [...mdfe.peri.filter((item: infProdutoPerigosoInterface) =>
                        item.id.toString() !== action.payload.id.toString())];
                }
            }
        },

        removeProdutoPerigosoMDFeTodos: (state, action: PayloadAction<{ mdfeId: number | string }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga.findIndex((item) => item.infMDFe
                ?.some((n: InfMDFesInterface) => n?.id?.toString() === action.payload.mdfeId.toString())
            )
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe
                    ?.find(n => n?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    mdfe.peri = [];
                }
            }

        },

        addProdutoPerigosoNFe: (state, action: PayloadAction<{
            nfeId: number | string; peri: infProdutoPerigosoInterface
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infNFe
                    ?.some((nfe: infNFesInterface) => nfe?.id?.toString() === action.payload.nfeId.toString())
                )
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe
                    ?.find(nfe => nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    nfe.peri = nfe.peri || [];
                    nfe.peri.push(action.payload.peri);
                }
            }
        },

        removeProdutoPerigosoNFe: (state, action: PayloadAction<{
            nfeId: number | string; id: number | string
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infNFe
                    ?.some((nfe: infNFesInterface) => nfe?.id?.toString() === action.payload.nfeId.toString())
                )
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe
                    ?.find(nfe => nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    nfe.peri = [...nfe.peri.filter(item => item.id.toString() !== action.payload.id.toString())];

                }
            }

        },

        removeProdutoPerigosoNFeTodos: (state, action: PayloadAction<{ nfeId: number | string }>) => {
            const nfeIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infNFe?.some((nfe: infNFesInterface) => nfe?.id?.toString() === action.payload.nfeId.toString())
            )
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    nfe.peri = [];

                }
            }
        },

        addProdutoPerigosoCTe: (state, action: PayloadAction<{
            cteId: number | string; peri: infProdutoPerigosoInterface
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe
                    ?.some((cte: infCTesInterface) => cte?.id?.toString() === action.payload.cteId.toString())
                )
            if (cteIndex !== -1) {
                const cte = state.manifesto.infMunDescarga[cteIndex].infCTe
                    ?.find(cte => cte?.id?.toString() === action.payload.cteId.toString());
                if (cte) {
                    cte.peri = cte.peri || [];
                    cte.peri.push(action.payload.peri);
                }
            }
        },

        removeProdutoPerigosoCTe: (state, action: PayloadAction<{
            cteId: number | string; id: number | string
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe
                    ?.some((cte: infCTesInterface) => cte?.id?.toString() === action.payload.cteId.toString())
                )
            if (cteIndex !== -1) {
                const cte = state.manifesto.infMunDescarga[cteIndex].infCTe
                    ?.find(cte => cte?.id?.toString() === action.payload.cteId.toString());
                if (cte) {
                    cte.peri = [...cte.peri.filter((item: infProdutoPerigosoInterface) => item.id.toString() !== action.payload.id.toString())];

                }
            }

        },

        removeProdutoPerigosoCTeTodos: (state, action: PayloadAction<{ cteId: number | string }>) => {
            const cteIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infCTe?.some((cte: infCTesInterface) => cte?.id?.toString() === action.payload.cteId.toString())
            )
            if (cteIndex !== -1) {
                const cte = state.manifesto.infMunDescarga[cteIndex].infCTe?.find(cte =>
                    cte?.id?.toString() === action.payload.cteId.toString());
                if (cte) {
                    cte.peri = [];

                }
            }
        },

        addUnidadeTransporteNFe: (state, action: PayloadAction<{
            nfeId: number | string; data: infUnidTranspInterface
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infNFe?.some((nfe: infNFesInterface) => nfe?.id?.toString() === action.payload.nfeId.toString())
            )
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    nfe.infUnidTransp = nfe.infUnidTransp || [];
                    nfe.infUnidTransp.push(action.payload.data);
                }
            }
        },

        removeUnidadeTransporteNFe: (state, action: PayloadAction<{
            nfeId: number | string; id: number | string
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infNFe?.some((nfe: infNFesInterface) => nfe?.id?.toString() === action.payload.nfeId.toString())
            )
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    nfe.infUnidTransp = (
                        nfe.infUnidTransp || []).filter(item => item.id.toString() !== action.payload.id.toString());
                }
            }

        },

        removeUnidadeTransporteNFeTodos: (state, action: PayloadAction<{ nfeId: number | string }>) => {
            const nfeIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infNFe?.some((nfe: infNFesInterface) => nfe?.id?.toString() === action.payload.nfeId.toString())
            )
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    nfe.infUnidTransp = [];

                }
            }
        },

        addUnidadeTransporteCTe: (state, action: PayloadAction<{
            cteId: number | string; data: infUnidTranspInterface
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infCTe?.some((cte: infCTesInterface) => cte?.id?.toString() === action.payload.cteId.toString())
            )
            console.log('index', cteIndex)
            if (cteIndex !== -1) {
                const cte = state.manifesto.infMunDescarga[cteIndex].infCTe?.find(cte =>
                    cte?.id?.toString() === action.payload.cteId.toString());
                if (cte) {
                    cte.infUnidTransp = cte.infUnidTransp || [];
                    cte.infUnidTransp.push(action.payload.data);
                }
            }
        },

        removeUnidadeTransporteCTe: (state, action: PayloadAction<{
            cteId: number | string; id: number | string
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infCTe?.some((nfe: infCTesInterface) => nfe?.id?.toString() === action.payload.cteId.toString())
            )
            if (cteIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[cteIndex].infCTe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.cteId.toString());
                if (nfe) {
                    nfe.infUnidTransp = (
                        nfe.infUnidTransp || []).filter((item: infUnidTranspInterface) => item.id.toString() !== action.payload.id.toString());
                }
            }

        },

        removeUnidadeTransporteCTeTodos: (state, action: PayloadAction<{ cteId: number | string }>) => {
            const cteIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infCTe?.some((nfe: infCTesInterface) => nfe?.id?.toString() === action.payload.cteId.toString())
            )
            if (cteIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[cteIndex].infCTe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.cteId.toString());
                if (nfe) {
                    nfe.infUnidTransp = [];

                }
            }
        },


        addUnidadeTransporteMDFe: (state, action: PayloadAction<{
            mdfeId: number | string; data: infUnidTranspInterface
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infMDFe?.some((n: InfMDFesInterface) => n?.id?.toString() === action.payload.mdfeId.toString())
            )
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe?.find(mdfe =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    mdfe.infUnidTransp = mdfe.infUnidTransp || [];
                    mdfe.infUnidTransp.push(action.payload.data);
                }
            }
        },

        removeUnidadeTransporteMDFe: (state, action: PayloadAction<{
            mdfeId: number | string; id: number | string
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infMDFe?.some((n: InfMDFesInterface) => n?.id?.toString() === action.payload.mdfeId.toString())
            )
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe?.find(mdfe =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    mdfe.infUnidTransp = (
                        mdfe.infUnidTransp || []).filter((item: infUnidTranspInterface) => item.id.toString() !== action.payload.id.toString());
                }
            }
        },

        removeUnidadeTransporteMDFeTodos: (state, action: PayloadAction<{ mdfeId: number | string }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga.findIndex((item) =>
                item.infMDFe?.some((n: InfMDFesInterface) => n?.id?.toString() === action.payload.mdfeId.toString())
            )
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe?.find(mdfe =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    mdfe.infUnidTransp = [];
                }
            }
        },

        addLacreUnidadeTransporteNFe: (state, action: PayloadAction<{
            nfeId: number | string; idUnidadeTransprte: number | string; lacre: LacUnidadeTransporteInterface
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infNFe?.some((nfe: infNFesInterface) =>
                    nfe?.id?.toString() === action.payload.nfeId.toString()));
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp
                        ?.find(unid => unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.lacUnidTransp = unidTransp.lacUnidTransp || [];
                        unidTransp.lacUnidTransp.push(action.payload.lacre);
                    }
                }
            }
        },
        removeLacreUnidadeTransporteNFe: (state, action: PayloadAction<{
            nfeId: number | string; idUnidadeTransprte: number | string; idLacre: number | string
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infNFe
                    ?.some((nfe: infNFesInterface) => nfe?.id?.toString() === action.payload.nfeId.toString()));
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp
                        ?.find(unid => unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.lacUnidTransp = (unidTransp.lacUnidTransp || []).filter(lacre =>
                            lacre.id.toString() !== action.payload.idLacre.toString());
                    }
                }
            }
        },

        removeLacreUnidadeTransporteNFeTodos: (state, action: PayloadAction<{
            nfeId: number | string; idUnidadeTransprte: number | string
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe?.some((nfe: infCTesInterface) =>
                    nfe?.id?.toString() === action.payload.nfeId.toString()));
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infCTe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.lacUnidTransp = [];
                    }
                }
            }
        },

        addLacreUnidadeTransporteCTe: (state, action: PayloadAction<{
            cteId: number | string; idUnidadeTransprte: number | string; lacre: LacUnidadeTransporteInterface
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe?.some((cte: infCTesInterface) =>
                    cte?.id?.toString() === action.payload.cteId.toString()));
            if (cteIndex !== -1) {
                const cte = state.manifesto.infMunDescarga[cteIndex].infCTe?.find(cte =>
                    cte?.id?.toString() === action.payload.cteId.toString());
                if (cte) {
                    const unidTransp = cte.infUnidTransp
                        ?.find((unid: infUnidTranspInterface) =>
                            unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.lacUnidTransp = unidTransp.lacUnidTransp || [];
                        unidTransp.lacUnidTransp.push(action.payload.lacre);
                    }
                }
            }
        },
        removeLacreUnidadeTransporteCTe: (state, action: PayloadAction<{
            cteId: number | string; idUnidadeTransprte: number | string; idLacre: number | string
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe
                    ?.some((cte: infCTesInterface) => cte?.id?.toString() === action.payload.cteId.toString()));
            if (cteIndex !== -1) {
                const cte = state.manifesto.infMunDescarga[cteIndex].infCTe?.find(cte =>
                    cte?.id?.toString() === action.payload.cteId.toString());
                if (cte) {
                    const unidTransp = cte.infUnidTransp
                        ?.find((unid: infUnidTranspInterface) =>
                            unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.lacUnidTransp = (unidTransp.lacUnidTransp || [])
                            .filter((lacre: LacUnidadeTransporteInterface) =>
                                lacre.id.toString() !== action.payload.idLacre.toString());
                    }
                }
            }
        },

        removeLacreUnidadeTransporteCTeTodos: (state, action: PayloadAction<{
            cteId: number | string; idUnidadeTransprte: number | string
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe?.some((cte: infCTesInterface) =>
                    cte?.id?.toString() === action.payload.cteId.toString()));
            if (cteIndex !== -1) {
                const cte = state.manifesto.infMunDescarga[cteIndex].infCTe?.find(cte =>
                    cte?.id?.toString() === action.payload.cteId.toString());
                if (cte) {
                    const unidTransp = cte.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.lacUnidTransp = [];
                    }
                }
            }
        },

        addLacreUnidadeTransporteMDFe: (state, action: PayloadAction<{
            mdfeId: number | string; idUnidadeTransprte: number | string; lacre: LacUnidadeTransporteInterface
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infMDFe?.some((mdfe: InfMDFesInterface) =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString()));
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe?.find(mdfe =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    const unidTransp = mdfe.infUnidTransp
                        ?.find((unid: infUnidTranspInterface) => unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.lacUnidTransp = unidTransp.lacUnidTransp || [];
                        unidTransp.lacUnidTransp.push(action.payload.lacre);
                    }
                }
            }
        },
        removeLacreUnidadeTransporteMDFe: (state, action: PayloadAction<{
            mdfeId: number | string; idUnidadeTransprte: number | string; idLacre: number | string
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infMDFe
                    ?.some((mdfe: InfMDFesInterface) => mdfe?.id?.toString() === action.payload.mdfeId.toString()));
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe?.find(mdfe =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    const unidTransp = mdfe.infUnidTransp
                        ?.find((unid: infUnidTranspInterface) => unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.lacUnidTransp = (unidTransp.lacUnidTransp || []).filter((lacre: LacUnidadeTransporteInterface) =>
                            lacre.id.toString() !== action.payload.idLacre.toString());
                    }
                }
            }
        },

        removeLacreUnidadeTransporteMDFeTodos: (state, action: PayloadAction<{
            mdfeId: number | string; idUnidadeTransprte: number | string
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infMDFe?.some((mdfe: InfMDFesInterface) =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString()));
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe?.find(mdfe =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    const unidTransp = mdfe.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.lacUnidTransp = [];
                    }
                }
            }
        },

        addUnidadeCargaUnidadeTransporteNFe: (state, action: PayloadAction<{
            nfeId: number | string; idUnidadeTransprte: number | string; data: InfUnidCargaInterface
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infNFe?.some((nfe: infNFesInterface) =>
                    nfe?.id?.toString() === action.payload.nfeId.toString()));
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp
                        ?.find(unid => unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.infUnidCarga = unidTransp.infUnidCarga || [];
                        unidTransp.infUnidCarga.push(action.payload.data);
                    }
                }
            }
        },

        removeUnidadeCargaUnidadeTransporteNFe: (state, action: PayloadAction<{
            nfeId: number | string; idUnidadeTransprte: number | string; id: number | string
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infNFe?.some((nfe: infNFesInterface) =>
                    nfe?.id?.toString() === action.payload.nfeId.toString()));
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe
                    ?.find(nfe => nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp?.find(unid =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.infUnidCarga = (unidTransp.infUnidCarga || [])
                            .filter(uc => uc.id.toString() !== action.payload.id.toString());
                    }
                }
            }
        },

        removeUnidadeCargaUnidadeTransporteNFeTodos: (state, action: PayloadAction<{
            nfeId: number | string; idUnidadeTransprte: number | string
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infNFe?.some((nfe: infNFesInterface) =>
                    nfe?.id?.toString() === action.payload.nfeId.toString()));
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe
                    ?.find(nfe => nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp?.find(unid =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.infUnidCarga = [];
                    }
                }
            }
        },


        addUnidadeCargaUnidadeTransporteCTe: (state, action: PayloadAction<{
            cteId: number | string; idUnidadeTransprte: number | string; data: InfUnidCargaInterface
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe?.some((nfe: infCTesInterface) =>
                    nfe?.id?.toString() === action.payload.cteId.toString()));
            if (cteIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[cteIndex].infCTe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.cteId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp
                        ?.find((unid: infUnidTranspInterface) =>
                            unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.infUnidCarga = unidTransp.infUnidCarga || [];
                        unidTransp.infUnidCarga.push(action.payload.data);
                    }
                }
            }
        },

        removeUnidadeCargaUnidadeTransporteCTe: (state, action: PayloadAction<{
            cteId: number | string; idUnidadeTransprte: number | string; id: number | string
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe?.some((nfe: infCTesInterface) =>
                    nfe?.id?.toString() === action.payload.cteId.toString()));
            if (cteIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[cteIndex].infCTe
                    ?.find(nfe => nfe?.id?.toString() === action.payload.cteId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.infUnidCarga = (unidTransp.infUnidCarga || [])
                            .filter((uc: InfUnidCargaInterface) => uc.id.toString() !== action.payload.id.toString());
                    }
                }
            }
        },

        removeUnidadeCargaUnidadeTransporteCTeTodos: (state, action: PayloadAction<{
            cteId: number | string; idUnidadeTransprte: number | string
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe?.some((nfe: infCTesInterface) =>
                    nfe?.id?.toString() === action.payload.cteId.toString()));
            if (cteIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[cteIndex].infCTe
                    ?.find(nfe => nfe?.id?.toString() === action.payload.cteId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.infUnidCarga = [];
                    }
                }
            }
        },

        addUnidadeCargaUnidadeTransporteMDFe: (state, action: PayloadAction<{
            mdfeId: number | string; idUnidadeTransprte: number | string; data: InfUnidCargaInterface
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infMDFe?.some((mdfe: InfMDFesInterface) =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString()));
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe?.find(mdfe =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    const unidTransp = mdfe.infUnidTransp
                        ?.find((unid: infUnidTranspInterface) =>
                            unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.infUnidCarga = unidTransp.infUnidCarga || [];
                        unidTransp.infUnidCarga.push(action.payload.data);
                    }
                }
            }
        },

        removeUnidadeCargaUnidadeTransporteMDFe: (state, action: PayloadAction<{
            mdfeId: number | string; idUnidadeTransprte: number | string; id: number | string
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infMDFe?.some((mdfe: InfMDFesInterface) =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString()));
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe
                    ?.find(mdfe => mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    const unidTransp = mdfe.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.infUnidCarga = (unidTransp.infUnidCarga || [])
                            .filter((uc: InfUnidCargaInterface) => uc.id.toString() !== action.payload.id.toString());
                    }
                }
            }
        },

        removeUnidadeCargaUnidadeTransporteMDFeTodos: (state, action: PayloadAction<{
            mdfeId: number | string; idUnidadeTransprte: number | string
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infMDFe?.some((mdfe: InfMDFesInterface) =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString()));
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe
                    ?.find(mdfe => mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    const unidTransp = mdfe.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        unidTransp.infUnidCarga = [];
                    }
                }
            }
        },

        addLacreUnidadeCargaUnidadeTransporteNFe: (state, action: PayloadAction<{
            nfeId: number | string;
            idUnidadeTransprte: number | string;
            idUnidadeCarga: number | string;
            lacre: LacUnidCargaInterface
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infNFe?.some((nfe: infNFesInterface) =>
                    nfe?.id?.toString() === action.payload.nfeId.toString()));
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp?.find(unid =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        const unidCarga = unidTransp.infUnidCarga
                            ?.find(uc => uc.id.toString() === action.payload.idUnidadeCarga.toString());
                        if (unidCarga) {
                            unidCarga.lacUnidCarga = unidCarga.lacUnidCarga || [];
                            unidCarga.lacUnidCarga.push(action.payload.lacre);
                        }
                    }
                }
            }
        },

        removeLacreUnidadeCargaUnidadeTransporteNFe: (state, action: PayloadAction<{
            nfeId: number | string;
            idUnidadeTransprte: number | string;
            idUnidadeCarga: number | string;
            idLacre: number | string
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infNFe?.some((nfe: infNFesInterface) =>
                    nfe?.id?.toString() === action.payload.nfeId.toString()));
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp?.find(unid =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        const unidCarga = unidTransp.infUnidCarga
                            ?.find(uc => uc.id.toString() === action.payload.idUnidadeCarga.toString());
                        if (unidCarga) {
                            unidCarga.lacUnidCarga = (unidCarga.lacUnidCarga || [])
                                .filter(lacre => lacre.id.toString() !== action.payload.idLacre.toString());
                        }
                    }
                }
            }
        },

        removeLacreUnidadeCargaUnidadeTransporteNFeTodos: (state, action: PayloadAction<{
            nfeId: number | string; idUnidadeTransprte: number | string; idUnidadeCarga: number | string
        }>) => {
            const nfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infNFe?.some((nfe: infNFesInterface) =>
                    nfe?.id?.toString() === action.payload.nfeId.toString()));
            if (nfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[nfeIndex].infNFe
                    ?.find(nfe => nfe?.id?.toString() === action.payload.nfeId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp?.find(unid =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        const unidCarga = unidTransp.infUnidCarga
                            ?.find(uc => uc.id.toString() === action.payload.idUnidadeCarga.toString());
                        if (unidCarga) {
                            unidCarga.lacUnidCarga = [];
                        }
                    }
                }
            }
        },

        addLacreUnidadeCargaUnidadeTransporteCTe: (state, action: PayloadAction<{
            cteId: number | string;
            idUnidadeTransprte: number | string;
            idUnidadeCarga: number | string;
            lacre: LacUnidCargaInterface
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe?.some((cte: infCTesInterface) =>
                    cte?.id?.toString() === action.payload.cteId.toString()));
            if (cteIndex !== -1) {
                const cte = state.manifesto.infMunDescarga[cteIndex].infCTe?.find(cte =>
                    cte?.id?.toString() === action.payload.cteId.toString());
                if (cte) {
                    const unidTransp = cte.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        const unidCarga = unidTransp.infUnidCarga
                            ?.find((uc: InfUnidCargaInterface) => uc.id.toString() === action.payload.idUnidadeCarga.toString());
                        if (unidCarga) {
                            unidCarga.lacUnidCarga = unidCarga.lacUnidCarga || [];
                            unidCarga.lacUnidCarga.push(action.payload.lacre);
                        }
                    }
                }
            }
        },

        removeLacreUnidadeCargaUnidadeTransporteCTe: (state, action: PayloadAction<{
            cteId: number | string;
            idUnidadeTransprte: number | string;
            idUnidadeCarga: number | string;
            idLacre: number | string
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe?.some((cte: infCTesInterface) =>
                    cte?.id?.toString() === action.payload.cteId.toString()));
            if (cteIndex !== -1) {
                const cte = state.manifesto.infMunDescarga[cteIndex].infCTe?.find(cte =>
                    cte?.id?.toString() === action.payload.cteId.toString());
                if (cte) {
                    const unidTransp = cte.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        const unidCarga = unidTransp.infUnidCarga
                            ?.find((uc: InfUnidCargaInterface) => uc.id.toString() === action.payload.idUnidadeCarga.toString());
                        if (unidCarga) {
                            unidCarga.lacUnidCarga = (unidCarga.lacUnidCarga || [])
                                .filter((lacre: LacUnidadeTransporteInterface) => lacre.id.toString() !== action.payload.idLacre.toString());
                        }
                    }
                }
            }
        },

        removeLacreUnidadeCargaUnidadeTransporteCTeTodos: (state, action: PayloadAction<{
            cteId: number | string; idUnidadeTransprte: number | string; idUnidadeCarga: number | string
        }>) => {
            const cteIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infCTe?.some((cte: infCTesInterface) =>
                    cte?.id?.toString() === action.payload.cteId.toString()));
            if (cteIndex !== -1) {
                const cte = state.manifesto.infMunDescarga[cteIndex].infCTe
                    ?.find(cte => cte?.id?.toString() === action.payload.cteId.toString());
                if (cte) {
                    const unidTransp = cte.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        const unidCarga = unidTransp.infUnidCarga
                            ?.find((uc: InfUnidCargaInterface) => uc.id.toString() === action.payload.idUnidadeCarga.toString());
                        if (unidCarga) {
                            unidCarga.lacUnidCarga = [];
                        }
                    }
                }
            }
        },

        addLacreUnidadeCargaUnidadeTransporteMDFe: (state, action: PayloadAction<{
            mdfeId: number | string;
            idUnidadeTransprte: number | string;
            idUnidadeCarga: number | string;
            lacre: LacUnidCargaInterface
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infMDFe?.some((mdfe: InfMDFesInterface) =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString()));
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe?.find(mdfe =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    const unidTransp = mdfe.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        const unidCarga = unidTransp.infUnidCarga
                            ?.find((uc: InfUnidCargaInterface) =>
                                uc.id.toString() === action.payload.idUnidadeCarga.toString());
                        if (unidCarga) {
                            unidCarga.lacUnidCarga = unidCarga.lacUnidCarga || [];
                            unidCarga.lacUnidCarga.push(action.payload.lacre);
                        }
                    }
                }
            }
        },

        removeLacreUnidadeCargaUnidadeTransporteMDFe: (state, action: PayloadAction<{
            mdfeId: number | string;
            idUnidadeTransprte: number | string;
            idUnidadeCarga: number | string;
            idLacre: number | string
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infMDFe?.some((nfe: InfMDFesInterface) =>
                    nfe?.id?.toString() === action.payload.mdfeId.toString()));
            if (mdfeIndex !== -1) {
                const nfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe?.find(nfe =>
                    nfe?.id?.toString() === action.payload.mdfeId.toString());
                if (nfe) {
                    const unidTransp = nfe.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        const unidCarga = unidTransp.infUnidCarga
                            ?.find((uc: InfUnidCargaInterface) =>
                                uc.id.toString() === action.payload.idUnidadeCarga.toString());
                        if (unidCarga) {
                            unidCarga.lacUnidCarga = (unidCarga.lacUnidCarga || [])
                                .filter((lacre: LacUnidCargaInterface) =>
                                    lacre.id.toString() !== action.payload.idLacre.toString());
                        }
                    }
                }
            }
        },

        removeLacreUnidadeCargaUnidadeTransporteMDFeTodos: (state, action: PayloadAction<{
            mdfeId: number | string; idUnidadeTransprte: number | string; idUnidadeCarga: number | string
        }>) => {
            const mdfeIndex = state.manifesto.infMunDescarga
                .findIndex((item) => item.infMDFe?.some((mdfe: InfMDFesInterface) =>
                    mdfe?.id?.toString() === action.payload.mdfeId.toString()));
            if (mdfeIndex !== -1) {
                const mdfe = state.manifesto.infMunDescarga[mdfeIndex].infMDFe
                    ?.find(mdfe => mdfe?.id?.toString() === action.payload.mdfeId.toString());
                if (mdfe) {
                    const unidTransp = mdfe.infUnidTransp?.find((unid: infUnidTranspInterface) =>
                        unid.id.toString() === action.payload.idUnidadeTransprte.toString());
                    if (unidTransp) {
                        const unidCarga = unidTransp.infUnidCarga
                            ?.find((uc: InfUnidCargaInterface) =>
                                uc.id.toString() === action.payload.idUnidadeCarga.toString());
                        if (unidCarga) {
                            unidCarga.lacUnidCarga = [];
                        }
                    }
                }
            }
        },


        clearCTe: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infMunDescarga: [...state.manifesto.infMunDescarga.map(item => {
                        return {
                            id: item.id,
                            municipio_id: item.municipio_id,
                            name: item.name,
                            infNFe: item.infNFe,
                            infMDFe: item.infMDFe,
                            infCTe: []
                        }
                    })]

                },
            }
        },

        addCTe: (state, action: PayloadAction<infCTesInterface>) => {
            const index = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())

            if (index !== -1) {
                state.manifesto.infMunDescarga[index].infCTe?.push(action.payload)
            }

        },

        removeCTe: (state, action: PayloadAction<{ municipio_id: number; id: string | number }>) => {
            const munDescarga = state.manifesto.infMunDescarga.filter((item) => item.municipio_id === action.payload.municipio_id)
            const index = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id === action.payload.municipio_id)
            let newLista

            if (index !== -1) {
                newLista = state.manifesto.infMunDescarga[index].infCTe?.filter((item: infCTesInterface) => item.id?.toString() !== action.payload.id.toString()) || []

                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        infMunDescarga: [
                            ...state.manifesto.infMunDescarga.filter(item => item.municipio_id !== action.payload.municipio_id),
                            {
                                id: munDescarga[0].id,
                                municipio_id: action.payload.municipio_id,
                                name: munDescarga[0].name,
                                infCTe: newLista,
                                infNFe: munDescarga[0].infNFe,
                                infMDFe: munDescarga[0].infMDFe
                            }
                        ]
                    }
                }
            }

        },

        updateCTe: (state, action: PayloadAction<infCTesInterface>) => {

            const nfe = state.manifesto.infMunDescarga.flatMap((item) => item.infCTe as infCTesInterface[]).find((item) => item.id === action.payload.id);

            if (nfe) {
                const index = state.manifesto.infMunDescarga.findIndex(item => item.municipio_id.toString() === nfe.municipio_id.toString());

                if (index !== -1) {
                    let newLista = state.manifesto.infMunDescarga[index].infCTe?.filter((item: infCTesInterface) => item.id !== action.payload.id) || []
                    state.manifesto.infMunDescarga[index].infCTe = newLista;

                    const index2 = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())

                    if (index2 !== -1) {
                        state.manifesto.infMunDescarga[index2].infCTe?.push(action.payload)
                    }
                }
            }
        },

        addTracaoReboque: (state, action: PayloadAction<ReboqueInterface>) => {
            if (state.manifesto.modal === 1) {
                state.manifesto.modal_rodoviario.reboques.push(action.payload);
            }
        },

        removeTracaoReboque: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        reboques: state.manifesto.modal_rodoviario.reboques.filter((item: ReboqueInterface) => item.id?.toString() !== action.payload)
                    }
                }
            }
        },

        updateTracaoReboque: (state, action: PayloadAction<ReboqueInterface>) => {
            const index = state.manifesto.modal_rodoviario.reboques.findIndex((item: ReboqueInterface) => item.id === action.payload.id);
            if (index !== -1) {
                state.manifesto.modal_rodoviario.reboques[index] = action.payload;
            }
        },

        removeTracaoReboqueTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        reboques: []
                    }
                }
            }
        },

        addCiot: (state, action: PayloadAction<CiotInterface>) => {
            state.manifesto.modal_rodoviario.infANTT?.infCIOT.push(action.payload);
        },

        removeCiot: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT,
                            infCIOT: state.manifesto.modal_rodoviario.infANTT.infCIOT.filter((item: CiotInterface) => item.id !== action.payload)
                        }
                    }
                }
            }
        },

        removeCiotTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT,
                            infCIOT: []
                        }
                    }
                }
            }
        },

        addContratante: (state, action: PayloadAction<ContratanteInterface>) => {
            state.manifesto.modal_rodoviario.infANTT?.infContratante.push(action.payload);
        },

        removeContratante: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT,
                            infContratante: state.manifesto.modal_rodoviario.infANTT.infContratante.filter((item: ContratanteInterface) => item.id !== action.payload)
                        }
                    }
                }
            }
        },

        removeContratanteTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT,
                            infContratante: []
                        }
                    }
                }
            }
        },

        addDispositivoValePedagio: (state, action: PayloadAction<DispInterface>) => {
            state.manifesto.modal_rodoviario.infANTT?.valePed?.disp.push(action.payload);
        },

        removeDispositivoValePedagio: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT,
                            valePed: {
                                ...state.manifesto.modal_rodoviario.infANTT.valePed,
                                disp: state.manifesto.modal_rodoviario.infANTT.valePed.disp.filter((item: DispInterface) => item.id !== action.payload)
                            }
                        }
                    }
                }
            }
        },

        removeDispositivoValePedagioTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT,
                            valePed: {
                                ...state.manifesto.modal_rodoviario.infANTT.valePed,
                                disp: []
                            }
                        }
                    }
                }
            }
        },

        changeValePedCategoria: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT,
                            valePed: {
                                ...state.manifesto.modal_rodoviario.infANTT.valePed,
                                categCombVeic: action.payload
                            }
                        }
                    }
                }
            }
        },

        addInfPag: (state, action: PayloadAction<infPagInterface>) => {
            const sequencias = state.manifesto.modal_rodoviario.infANTT?.infPag.map((item: infPagInterface) => item.id) || []
            const maxSeq = Math.max(sequencias) + 1;

            state.manifesto.modal_rodoviario.infANTT?.infPag.push({
                id: maxSeq,
                xNome: action.payload.xNome,
                cpfcnpj: action.payload.cpfcnpj,
                idestrangeiro: action.payload.idestrangeiro,
                vContrato: action.payload.vContrato,
                indAltoDesemp: action.payload.indAltoDesemp,
                indPag: action.payload.indPag,
                vAdiant: action.payload.vAdiant,
                indAntecipaAdiant: action.payload.indAntecipaAdiant,
                tpAntecip: action.payload.tpAntecip,
                codBanco: action.payload.codBanco,
                codAgencia: action.payload.codAgencia,
                CNPJIPEF: action.payload.CNPJIPEF,
                PIX: action.payload.PIX,
                comp: action.payload.comp,
                infPrazo: action.payload.infPrazo,

            });
        },

        removeInfPag: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT,
                            infPag: state.manifesto.modal_rodoviario.infANTT.infPag.filter((item: infPagInterface) => item.id !== action.payload)
                        }
                    }
                }
            }
        },

        removeInfPagTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_rodoviario: {
                        ...state.manifesto.modal_rodoviario,
                        infANTT: {
                            ...state.manifesto.modal_rodoviario.infANTT,
                            infPag: []
                        }
                    }
                }
            }
        },

        addSeguro: (state, action: PayloadAction<SeguroInterface>) => {
            state.manifesto.seg.push(action.payload);
        },

        removeSeguro: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    seg: state.manifesto.seg.filter((item: SeguroInterface) => item.id !== action.payload)
                }
            }
        },

        removeSeguroTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    seg: []
                }
            }
        },

        updateSeguro: (state, action: PayloadAction<SeguroInterface>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    seg: state.manifesto.seg.map((item: SeguroInterface) =>
                        item.id === action.payload.id ? { ...action.payload } : item
                    )
                }
            }
        },

        addAvervacao: (state, action: PayloadAction<{ seguro_id: string | number, nAver: AverbacaoInterface }>) => {
            const seguro = state.manifesto.seg.find(item => item.id.toString() === action.payload.seguro_id.toString());
            if (!seguro) {
                return state;
            }

            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    seg: state.manifesto.seg.map(item =>
                        item.id.toString() === action.payload.seguro_id.toString()
                            ? {
                                ...item,
                                nAver: [...(item.nAver || []), action.payload.nAver]
                            }
                            : item
                    )
                }
            };
        },

        removeAvervacao: (state, action: PayloadAction<{ seguro_id: string | number, id: string | number }>) => {
            const seguro = state.manifesto.seg.find(item => item.id.toString() === action.payload.seguro_id.toString());
            if (!seguro) {
                return state;
            }

            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    seg: state.manifesto.seg.map(item =>
                        item.id.toString() === action.payload.seguro_id.toString()
                            ? {
                                ...item,
                                nAver: (item.nAver || []).filter(av => av.id.toString() !== action.payload.id.toString())
                            }
                            : item
                    )
                }
            };
        },

        removeAvervacaoTodos: (state, action: PayloadAction<{ seguro_id: string | number }>) => {
            const seguro = state.manifesto.seg.find(item => item.id.toString() === action.payload.seguro_id.toString());
            if (!seguro) {
                return state;
            }

            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    seg: state.manifesto.seg.map(item =>
                        item.id.toString() === action.payload.seguro_id.toString()
                            ? {
                                ...item,
                                nAver: []
                            }
                            : item
                    )
                }
            };
        },

        addVagao: (state, action: PayloadAction<VagaoInterface>) => {
            state.manifesto.modal_ferroviario.vag.push(action.payload)
        },

        removeVagao: (state, action: PayloadAction<number | string>) => {

            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_ferroviario: {
                        ...state.manifesto.modal_ferroviario,
                        vag: state.manifesto.modal_ferroviario.vag.filter((item: VagaoInterface) =>
                            item.id.toString() !== action.payload.toString()
                        )
                    }
                }
            }
        },

        removeVagaoTodos: (state) => {

            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_ferroviario: {
                        ...state.manifesto.modal_ferroviario,
                        vag: []
                    }
                }
            }
        },

        changeModalAquatico: (state, action) => {
            if (state.manifesto.modal_aquatico) {

                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        modal_aquatico: {
                            ...state.manifesto.modal_aquatico, ...action.payload
                        }
                    },

                }
            }

        },

        addTerminalCarrega: (state, action: PayloadAction<InfTermCarregInterface>) => {
            state.manifesto.modal_aquatico.infTermCarreg.push(action.payload);
        },

        removeTerminalCarrega: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aquatico: {
                        ...state.manifesto.modal_aquatico,
                        infTermCarreg: state.manifesto.modal_aquatico.infTermCarreg.filter(
                            (item: InfTermCarregInterface) => item.id.toString() !== action.payload.toString()
                        )
                    }
                }
            }
        },

        removeTerminalCarregaTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aquatico: {
                        ...state.manifesto.modal_aquatico,
                        infTermCarreg: []
                    }
                }
            }
        },

        addTerminalDescarrega: (state, action: PayloadAction<infTermDescarregInterface>) => {
            state.manifesto.modal_aquatico.infTermDescarreg.push(action.payload);
        },

        removeTerminalDescarrega: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aquatico: {
                        ...state.manifesto.modal_aquatico,
                        infTermDescarreg: state.manifesto.modal_aquatico.infTermDescarreg.filter(
                            (item: infTermDescarregInterface) => item.id.toString() !== action.payload.toString()
                        )
                    }
                }
            }
        },

        removeTerminalDescarregaTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aquatico: {
                        ...state.manifesto.modal_aquatico,
                        infTermDescarreg: []
                    }
                }
            }
        },

        addComboio: (state, action: PayloadAction<infEmbCombInterface>) => {
            state.manifesto.modal_aquatico.infEmbComb.push(action.payload);
        },

        removeComboio: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aquatico: {
                        ...state.manifesto.modal_aquatico,
                        infEmbComb: state.manifesto.modal_aquatico.infEmbComb.filter(
                            (item: infEmbCombInterface) => item.id.toString() !== action.payload.toString()
                        )
                    }
                }
            }
        },

        removeComboioTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aquatico: {
                        ...state.manifesto.modal_aquatico,
                        infEmbComb: []
                    }
                }
            }
        },

        addUnidadeCargaVazia: (state, action: PayloadAction<infUnidCargaVaziaInteface>) => {
            state.manifesto.modal_aquatico.infUnidCargaVazia.push(action.payload);
        },

        removeUnidadeCargaVazia: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aquatico: {
                        ...state.manifesto.modal_aquatico,
                        infUnidCargaVazia: state.manifesto.modal_aquatico.infUnidCargaVazia.filter(
                            (item: infUnidCargaVaziaInteface) => item.id.toString() !== action.payload.toString()
                        )
                    }
                }
            }
        },

        removeUnidadeCargaVaziaTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aquatico: {
                        ...state.manifesto.modal_aquatico,
                        infUnidCargaVazia: []
                    }
                }
            }
        },
        addUnidadeTransporteVazia: (state, action: PayloadAction<infUnidTranspVaziaInterface>) => {
            state.manifesto.modal_aquatico.infUnidTranspVazia.push(action.payload);
        },

        removeUnidadeTransporteVazia: (state, action: PayloadAction<number | string>) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aquatico: {
                        ...state.manifesto.modal_aquatico,
                        infUnidTranspVazia: state.manifesto.modal_aquatico.infUnidTranspVazia.filter(
                            (item: infUnidTranspVaziaInterface) => item.id.toString() !== action.payload.toString()
                        )
                    }
                }
            }
        },

        removeUnidadeTransporteVaziaTodos: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    modal_aquatico: {
                        ...state.manifesto.modal_aquatico,
                        infUnidTranspVazia: []
                    }
                }
            }
        },

        addMDFe: (state, action: PayloadAction<InfMDFesInterface>) => {
            const index = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())

            if (index !== -1) {
                state.manifesto.infMunDescarga[index].infMDFe?.push(action.payload)
            }

        },

        updateMDFe: (state, action: PayloadAction<InfMDFesInterface>) => {

            const nfe = state.manifesto.infMunDescarga.flatMap((item) => item.infMDFe as InfMDFesInterface[]).find((item) => item.id === action.payload.id);

            if (nfe) {
                const index = state.manifesto.infMunDescarga.findIndex(item => item.municipio_id.toString() === nfe.municipio_id.toString());

                if (index !== -1) {
                    let newLista = state.manifesto.infMunDescarga[index].infMDFe?.filter((item: InfMDFesInterface) => item.id !== action.payload.id) || []
                    state.manifesto.infMunDescarga[index].infMDFe = newLista;

                    const index2 = state.manifesto.infMunDescarga.findIndex((item) => item.municipio_id.toString() === action.payload.municipio_id.toString())

                    if (index2 !== -1) {
                        state.manifesto.infMunDescarga[index2].infMDFe?.push(action.payload)
                    }
                }
            }
        },



        removeMDFe: (state, action: PayloadAction<{ municipio_id: number; id: string | number }>) => {

            const munDescarga = state.manifesto.infMunDescarga.filter((item: infMunDescargaInterface) => item.municipio_id === action.payload.municipio_id)
            const index = state.manifesto.infMunDescarga.findIndex((item: infMunDescargaInterface) => item.municipio_id === action.payload.municipio_id)

            if (index !== -1) {
                let newLista = state.manifesto.infMunDescarga[index].infMDFe?.filter((item: InfMDFesInterface) => item.id?.toString() !== action.payload.id.toString()) || []

                return {
                    ...state,
                    manifesto: {
                        ...state.manifesto,
                        infMunDescarga: [
                            ...state.manifesto.infMunDescarga.filter(item => item.municipio_id !== action.payload.municipio_id),
                            {
                                id: munDescarga[0].id,
                                municipio_id: action.payload.municipio_id,
                                name: munDescarga[0].name,
                                infNFe: munDescarga[0].infNFe,
                                infCTe: munDescarga[0].infCTe,
                                infMDFe: newLista,
                            }
                        ]
                    }
                }
            }

        },

        clearMDFe: (state) => {
            return {
                ...state,
                manifesto: {
                    ...state.manifesto,
                    infMunDescarga: [...state.manifesto.infMunDescarga.map(item => {
                        return {
                            id: item.id,
                            municipio_id: item.municipio_id,
                            name: item.name,
                            infNFe: item.infNFe,
                            infCTe: item.infCTe,
                            infMDFe: [],
                        }
                    })]

                },
            }
        },

    }
});

export const { setEstados, setManifesto, setinfMunCarrega, removeInfMunCarrega, setinfPercurso, removeInfPercurso,
    setProdPred, removeProdPred, addAuthDownload, removeAuthDownload, setSelectMunicipios, addVagao, removeVagao,
    addListaMunicipiosCarregamento, removeMunicipioCarregamento, addListaUFPercurso, removeListaUFPercurso,
    gravarErrors, clearManifesto, changeProdutoPredominante, loadManifesto, addLacreManifesto, removerLacreManifesto,
    setSelectMunicipiosCarregamento, addListaMunicipiosDescarregamento, removeListaMunicipioDescarregamento,
    addNFe, removeNFe, clearNFe, addCTe, removeCTe, clearCTe, changeTracaoManifesto, clearError, changeTracaoProp,
    clearTracaoProp, addCondutor, removeCondutor, addLacreRodoviario, removerLacreRodoviario,
    loadMunicipiosDescargaSelect, addTracaoReboque, removeTracaoReboque, changeAnttRntrc, addCiot, removeCiot,
    addContratante, removeContratante, addDispositivoValePedagio, removeDispositivoValePedagio, changeValePedCategoria,
    addInfPag, removeInfPag, addSeguro, removeSeguro, updateNFe, changeModalAereo, changeModalFerroviarioTrem,
    changeModalAquatico, addTerminalCarrega, removeTerminalCarrega, addTerminalDescarrega, removeTerminalDescarrega,
    addComboio, removeComboio, addUnidadeCargaVazia, removeUnidadeCargaVazia, addUnidadeTransporteVazia,
    removeUnidadeTransporteVazia, updateCTe, addMDFe, removeMDFe, clearMDFe, updateMDFe, removerCondutorTodos,
    removeAuthDownloadTodos, removerLacreManifestoTodos, removeListaMunicipioDescarregamentoTodos,
    removeMunicipioCarregamentoTodos, removeListaUFPercursoTodos, removeTracaoReboqueTodos,
    removerLacreRodoviarioTodos, removeCiotTodos, removeContratanteTodos, removeDispositivoValePedagioTodos,
    removeInfPagTodos, removeSeguroTodos, removeComboioTodos, removeTerminalCarregaTodos,
    removeTerminalDescarregaTodos, removeUnidadeCargaVaziaTodos, removeUnidadeTransporteVaziaTodos,
    removeVagaoTodos, addAvervacao, removeAvervacao, removeAvervacaoTodos, addProdutoPerigosoNFe,
    removeProdutoPerigosoNFe, removeProdutoPerigosoNFeTodos, addUnidadeTransporteNFe, removeUnidadeTransporteNFe,
    removeUnidadeTransporteNFeTodos, addLacreUnidadeTransporteNFe, removeLacreUnidadeTransporteNFe,
    removeLacreUnidadeTransporteNFeTodos, addUnidadeCargaUnidadeTransporteNFe, removeUnidadeCargaUnidadeTransporteNFe,
    removeUnidadeCargaUnidadeTransporteNFeTodos, addLacreUnidadeCargaUnidadeTransporteNFe,
    removeLacreUnidadeCargaUnidadeTransporteNFe, removeLacreUnidadeCargaUnidadeTransporteNFeTodos, updateSeguro,
    removeProdutoPerigosoMDFe, removeProdutoPerigosoMDFeTodos, addProdutoPerigosoMDFe, addUnidadeTransporteMDFe,
    removeUnidadeTransporteMDFe, removeUnidadeTransporteMDFeTodos, addLacreUnidadeTransporteMDFe,
    removeLacreUnidadeTransporteMDFe, removeLacreUnidadeTransporteMDFeTodos, addUnidadeCargaUnidadeTransporteMDFe,
    removeUnidadeCargaUnidadeTransporteMDFe, removeUnidadeCargaUnidadeTransporteMDFeTodos,
    addLacreUnidadeCargaUnidadeTransporteMDFe, removeLacreUnidadeCargaUnidadeTransporteMDFe,
    removeLacreUnidadeCargaUnidadeTransporteMDFeTodos, addProdutoPerigosoCTe, removeProdutoPerigosoCTe,
    removeProdutoPerigosoCTeTodos, addUnidadeTransporteCTe, removeUnidadeTransporteCTe,
    removeUnidadeTransporteCTeTodos, addLacreUnidadeTransporteCTe, removeLacreUnidadeTransporteCTe,
    removeLacreUnidadeTransporteCTeTodos, addUnidadeCargaUnidadeTransporteCTe, removeUnidadeCargaUnidadeTransporteCTe,
    removeUnidadeCargaUnidadeTransporteCTeTodos, addLacreUnidadeCargaUnidadeTransporteCTe, 
    removeLacreUnidadeCargaUnidadeTransporteCTe, removeLacreUnidadeCargaUnidadeTransporteCTeTodos, updateTracaoReboque

} = manifestoSlice.actions;

export default manifestoSlice.reducer;